import { render, staticRenderFns } from "./SidebarOrg.vue?vue&type=template&id=eaf1bb24&"
import script from "./SidebarOrg.vue?vue&type=script&lang=js&"
export * from "./SidebarOrg.vue?vue&type=script&lang=js&"
import style0 from "./SidebarOrg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports